import React from "react";
import { Link, useNavigate } from "react-router-dom";

import ICONS from "../../constants/icons";

import { SidebarItem, WholeWrapper } from "./components";

const Sidebar = () => {
  const navigate = useNavigate();

  return (
    <WholeWrapper>
      <SidebarItem className="closer" onClick={() => navigate(-1)}>
        <ICONS.SidebarCloser />
      </SidebarItem>
      <Link to={"/music"}>
        <SidebarItem>
          <ICONS.SidebarProfile />
        </SidebarItem>
      </Link>
      <Link to={"/demo"}>
        <SidebarItem>
          <ICONS.SidebarPayments />
        </SidebarItem>
      </Link>
      <Link to={"/spotify"}>
        <SidebarItem>
          <ICONS.SidebarQuestions />
        </SidebarItem>
      </Link>
      <Link to={"/store"}>
        <SidebarItem>
          <ICONS.SidebarMarket />
        </SidebarItem>
      </Link>
    </WholeWrapper>
  );
};

export default Sidebar;
